module.exports = __webpack_public_path__ + "img/clothes-003.5f7c35a2.jpg";